import React from 'react';
import { ITooltip, Tooltip as ReactTooltip } from 'react-tooltip';
import { baseTooltipStyle } from './styles';

export const Tooltip = ({ style, ...props }: ITooltip) => <ReactTooltip style={{ ...baseTooltipStyle, ...style }} {...props} />;
